<template>
  <v-card>
    <v-card-text>
      <v-form v-model="valid" ref="form" id="tambahkan-komoditas-logistik" lazy-validation>
        <h2 style="margin: 0% auto;"><b>Tambahkan Pergerakan Barang Baru</b></h2>
        <h5>Kontrak > {{kodePenjualan}} > Tambahkan Pergerakan Barang Baru</h5>
        <v-layout row wrap>

            <!-- Bagian Umum -->
            <v-flex xs6>
                <v-subheader><h4><b>Bagian Umum</b></h4></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-hand-holding-usd" label="Tipe Pengiriman Pesanan" name="jenisPengirimanPesanan" v-model="jenisPengirimanPesanan" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-tag" label="Kode Penjualan" name="kodePenjualan" v-model="kodePenjualan" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="phone" label="Kontak Pembeli" name="kontakPembeli" v-model="kontakPembeli" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="phone" label="Kontak Penjual" name="kontakPenjual" v-model="kontakPenjual" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-select
                prepend-icon="fas fa-truck"
                v-model="statusPergerakanBarang"
                :items="tipeStatusPergerakanBarang"
                label="Status Pergerakan Barang"
                ></v-select>
                <small v-if="!isStatusPergerakanBarang" class="alert">Pilih Status Pergerakan Barang</small>
            </v-flex>

            <!-- Kontrak Komoditas -->
            <v-flex xs6>
                <v-subheader><h4><b>Kontrak Komoditas</b></h4></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <div class="layout row border">
                    <div class="layout column">
                        <p class="flex my-1 text-xs-left"><b>Penjual</b></p>
                        <p class="flex my-1 text-xs-left">Nama: <b>{{penjual}}</b></p>
                        <p class="flex my-2 text-xs-left">Entitas: <b>{{entitasPenjual}}</b></p>
                        <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPenjual}}</b></p>
                    </div>                

                    <div class="layout column">
                        <p class="flex my-1 text-xs-left"><b>Pembeli</b></p>
                        <p class="flex my-1 text-xs-left">Nama: <b>{{pembeli}}</b></p>
                        <p class="flex my-2 text-xs-left">Entitas: <b>{{entitasPembeli}}</b></p>
                        <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPembeli}}</b></p>
                    </div>                
                </div>
            </v-flex>

            <!-- Pelaku Usaha -->
            <v-flex xs6>
                <v-subheader><h4><b>Pelaku Usaha</b></h4></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="person" label="Nama Pembeli (Pelanggan)" name="pembeli" v-model="pembeli" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="phone" label="Kontak Pembeli (Pelanggan)" name="kontakPembeli" v-model="kontakPembeli" type="number" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-shipping-fast" label="Penyedia Jasa Pengiriman" name="penyediaJasaPengiriman" v-model="penyediaJasaPengiriman" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="phone" label="Kontak Penyedia Jasa Pengiriman" name="kontakPenyediaJasaPengiriman" v-model="kontakPenyediaJasaPengiriman" disabled append-icon="lock" type="number">
                </v-text-field>
            </v-flex>

            <!-- Penjelasan Pergerakan Barang -->
            <v-flex xs6>
                <v-subheader><h4><b>Penjelasan Pergerakan Barang</b></h4></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-apple-alt" label="Komoditas" name="komoditas" v-model="komoditas" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-balance-scale" label="Tingkat Kualitas" name="kualitas" v-model="kualitas" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-calendar" label="Musim" name="musim" v-model="musim" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-balance-scale" label="Kuantitas" name="kuantitas" v-model="kuantitas" :suffix="'/' + unitKuantitas" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-select
                prepend-icon="fas fa-truck"
                v-model="kendaraanAngkut"
                :items="tipeKendaraanAngkut"
                label="Pilih Kendaraan Angkut"
                ></v-select>
                <small v-if="!isKendaraanAngkut" class="alert">Pilih Jenis Kendaraan Angkut</small>
            </v-flex>

            <!-- Penjemputan -->
            <v-flex xs12>
                <v-subheader><h4><b>Penjemputan</b></h4></v-subheader>
            </v-flex>

            <v-flex sm6 lg6>
                <v-text-field
                    slot="activator"
                    label="Tanggal Mulai Penjemputan"
                    v-model="tanggalMulaiPenjemputan"
                    prepend-icon="event"
                    append-icon="lock"
                    readonly
                    disabled
                ></v-text-field>
            </v-flex>

            <v-flex sm6 lg6>
                <v-text-field
                    slot="activator"
                    label="Waktu Mulai Penjemputan"
                    v-model="waktuMulaiPenjemputan"
                    prepend-icon="access_time"
                    append-icon="lock"
                    readonly
                    disabled
                ></v-text-field>
            </v-flex> 

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="person" label="Nama Pengirim" name="pengirim" v-model="pengirim" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-map-marker-alt" label="Lokasi Penjemputan" name="lokasiPenjemputan" v-model="lokasiPenjemputan">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-tag" label="Kode Penjualan" name="kodePenjualan" v-model="kodePenjualanPenjemputan" append-icon="lock" disabled>
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-tag" label="Nomor Pesanan" name="kodePesananPenjemputanLogistik" v-model="kodePesananPenjemputanLogistik" maxlength="9">
                </v-text-field>
                <small v-if="!isKodePesananPenjemputanLogistik" class="alert">Kode Pesanan Penjemputan Harus 9 Karakter</small>
            </v-flex>

            <v-flex lg12 sm12>
                <v-textarea prepend-icon="fas fa-comment-dots" label="Instruksi Khusus Penjemputan" name="instruksiKhususPenjemputan" v-model="instruksiKhususPenjemputan" outline>
                </v-textarea>
                <small v-if="!isIntruksiKhususPenjemputan" class="alert">Masukan Instruksi Khusus Penjemputan (Opsional)</small>
            </v-flex>

            <!-- Pengiriman -->
            <v-flex xs12>
                <v-subheader><h4><b>Pengiriman</b></h4></v-subheader>
            </v-flex>

            <v-flex sm6 lg6>
                <v-text-field
                    slot="activator"
                    label="Tanggal Mulai Pengiriman"
                    v-model="tanggalMulaiPengiriman"
                    prepend-icon="event"
                    append-icon="lock"
                    readonly
                    disabled
                ></v-text-field>
            </v-flex>

            <v-flex sm6 lg6>
                <v-text-field
                    slot="activator"
                    label="Waktu Mulai Pengiriman"
                    v-model="waktuMulaiPengiriman"
                    prepend-icon="access_time"
                    append-icon="lock"
                    readonly
                    disabled
                ></v-text-field>
            </v-flex> 

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="person" label="Nama Penerima" name="penerima" v-model="penerima">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-map-marker-alt" label="Lokasi Penjemputan" name="lokasiPengiriman" v-model="lokasiPengiriman">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-tag" label="Kode Penjualan" name="kodePenjualanPengiriman" v-model="kodePenjualanPengiriman" append-icon="lock" disabled>
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-tag" label="Nomor Pengiriman" name="kodePesananPengirimanLogistik" v-model="kodePesananPengirimanLogistik" maxlength="9">
                </v-text-field>
                <small v-if="!isKodePesananPengirimanLogistik" class="alert">Kode Pesanan Pengiriman Harus 9 Karakter</small>
            </v-flex>

            <v-flex lg12 sm12>
                <v-textarea prepend-icon="fas fa-comment-dots" label="Instruksi Khusus Pengiriman" name="instruksiKhususPengiriman" v-model="instruksiKhususPengiriman" outline>
                </v-textarea>
                <small v-if="!isIntruksiKhususPengiriman" class="alert">Masukan Instruksi Khusus Pengiriman (Opsional)</small>
            </v-flex>

            <!-- Kontrak Pengiriman -->
            <v-flex xs12>
                <v-subheader><h4><b>Kontrak Pengiriman</b></h4></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-crosshairs" label="Perkiraan Jarak Tempuh" name="jarakTempuh" v-model="jarakTempuh" type="number" suffix="Km" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-crosshairs" label="Perkiraan Waktu Perjalanan" name="waktuPerjalanan" v-model="waktuTempuh" suffix="Jam" type="number" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

        </v-layout>        

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="back">Batal</v-btn>
          <v-btn color="secondary" @click="saveTemplate">Simpan Template</v-btn>
          <v-btn color="primary" form="tambahkan-komoditas-logistik" @click="getPesananPengiriman" :disabled="!isComplete">Lanjutkan dan Ulas</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>

      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  components: {
  },
  data: () => ({
    valid: true,
    date: '',
    modal: false ,

    // Bagian Umum 
    kodePenjualan: localStorage.kontrakKodePenjualan,
    komoditas: localStorage.kontrakKomoditas,
    dokumen: localStorage.kontrakDokumen,

    // Pelaku Usaha
    penjual: localStorage.kontrakPenjual,
    entitasPenjual: localStorage.kontrakEntitasPenjual,
    kontakPenjual: localStorage.kontrakKontakPenjual,
    emailPenjual: localStorage.kontrakEmailPenjual,
    faxPenjual: localStorage.kontrakFaxPenjual,
    alamatJalanPenjual: localStorage.kontrakAlamatJalanPenjual,
    alamatKelurahanPenjual: localStorage.kontrakAlamatKelurahanPenjual,
    alamatKecamatanPenjual: localStorage.kontrakAlamatKecamatanPenjual,
    alamatKabupatenPenjual: localStorage.kontrakAlamatKabupatenPenjual,
    alamatKotaPenjual: localStorage.kontrakAlamatKotaPenjual,
    alamatProvinsiPenjual: localStorage.kontrakAlamatProvinsiPenjual,
    alamatKodePosPenjual: localStorage.kontrakAlamatKodePosPenjual,

    pembeli: localStorage.kontrakPembeli,
    entitasPembeli: localStorage.kontrakEntitasPembeli,
    kontakPembeli: localStorage.kontrakKontakPembeli,
    emailPembeli: localStorage.kontrakEmailPembeli,
    faxPembeli: localStorage.kontrakFaxPembeli,
    alamatJalanPembeli: localStorage.kontrakAlamatJalanPembeli,
    alamatKelurahanPembeli: localStorage.kontrakAlamatKelurahanPembeli,
    alamatKecamatanPembeli: localStorage.kontrakAlamatKecamatanPembeli,
    alamatKabupatenPembeli: localStorage.kontrakAlamatKabupatenPembeli,
    alamatKotaPembeli: localStorage.kontrakAlamatKotaPembeli,
    alamatProvinsiPembeli: localStorage.kontrakAlamatProvinsiPembeli,
    alamatKodePosPembeli: localStorage.kontrakAlamatKodePosPembeli,

    // Penjelasan Kontrak
    jenisKontrak: localStorage.kontrakJenisKontrak,
    kuantitas: localStorage.kontrakKuantitas,
    unitKuantitas: localStorage.kontrakUnitKuantitas,
    kualitas: localStorage.kontrakKualitas,
    hargaKomoditas: localStorage.kontrakHargaKomoditas,
    tempatPembayaran: localStorage.kontrakTempatPembayaran,
    musim: localStorage.kontrakMusim,
    jalurPengiriman: localStorage.kontrakJalurPengiriman,
    skalaPembayaran: localStorage.kontrakSkalaPembayaran,
    batasTanggalPembayaran: localStorage.kontrakBatasTanggalPembayaran,
    batasWaktuPembayaran: localStorage.kontrakBatasWaktuPembayaran,
    toleransi: localStorage.kontrakToleransi,
    daerahPemasaran: localStorage.kontrakDaerahPemasaran,
    provinsiPemasaran: localStorage.kontrakProvinsiPemasaran, 

    // Rincian Pengiriman
    pengirim: localStorage.kontrakPengirim,
    kontakPengirim: localStorage.kontrakKontakPengirim,
    lokasiPenjemputan: localStorage.kontrakLokasiPenjemputan,
    alamatJalanPenjemputan: localStorage.kontrakAlamatJalanPenjemputan,
    alamatKelurahanPenjemputan: localStorage.kontrakAlamatKelurahanPenjemputan,
    alamatKecamatanPenjemputan: localStorage.kontrakAlamatKecamatanPenjemputan,
    alamatKabupatenPenjemputan: localStorage.kontrakAlamatKabupatenPenjemputan,
    alamatKotaPenjemputan: localStorage.kontrakAlamatKotaPenjemputan,
    alamatProvinsiPenjemputan: localStorage.kontrakAlamatProvinsiPenjemputan,
    alamatKodePosPenjemputan: localStorage.kontrakAlamatKodePosPenjemputan,

    penerima: localStorage.kontrakPenerima,
    kontakPenerima: localStorage.kontrakKontakPenerima,
    lokasiPengiriman: localStorage.kontrakLokasiPengiriman,
    alamatJalanPengiriman: localStorage.kontrakAlamatJalanPengiriman,
    alamatKelurahanPengiriman: localStorage.kontrakAlamatKelurahanPengiriman,
    alamatKecamatanPengiriman: localStorage.kontrakAlamatKecamatanPengiriman,
    alamatKabupatenPengiriman: localStorage.kontrakAlamatKabupatenPengiriman,
    alamatKotaPengiriman: localStorage.kontrakAlamatKotaPengiriman,
    alamatProvinsiPengiriman: localStorage.kontrakAlamatProvinsiPengiriman,  
    alamatKodePosPengiriman: localStorage.kontrakAlamatKodePosPengiriman,

    // Detail Pengiriman
    tanggalMulaiPengiriman: localStorage.kontrakTanggalMulaiPengiriman,
    waktuMulaiPengiriman: localStorage.kontrakWaktuMulaiPengiriman,
    tanggalBerakhirPengiriman: localStorage.kontrakTanggalBerakhirPengiriman,
    waktuBerakhirPengiriman: localStorage.kontrakWaktuBerakhirPengiriman,

    // Penjelasan Barang
    jenisPengepakan: localStorage.kontrakJenisPengepakan,

    // Kondisi Kontrak
    kondisiUmum: localStorage.kontrakKondisiUmum,
    kondisiKhusus: localStorage.kontrakKondisiKhusus,

    // Penilaian Kontrak
    nilai: localStorage.kontrakNilai,
    maxNilai: localStorage.kontrakMaxNilai,
    tanggalJatuhTempo: localStorage.kontrakTanggalJatuhTempo,
    waktuJatuhTempo: localStorage.kontrakWaktuJatuhTempo,

    // Usaha Pedagang Perantara
    jenisPembayaran: localStorage.kontrakJenisPembayaran,

    // Administrasi
    invoicing: localStorage.kontrakInvoicing,
    perantara: localStorage.kontrakPerantara,
    entitasPerantara: localStorage.kontrakEntitasPerantara,
    kontakPerantara: localStorage.kontrakKontakPerantara,
    catatanPedagang: localStorage.kontrakCatatanPedagang,

    // Sistem
    kontrakAktif: localStorage.kontrakActiveCurrentDate,
    kontrakId: localStorage.kontrakID,
    komoditasPesananPengirimanStatus: localStorage.komoditasPesananPengiriman,  
    komoditasPesananPengirimanAktif: localStorage.komoditasPesananPengirimanAktif,
    komoditasPesananPengirimanID: localStorage.komoditasPesananPengirimanID,
    komoditasStatusPedagangPerantara: localStorage.komoditasPesananPedagangPerantara,
    komoditasStatusPesananLogistik: localStorage.komoditasPesananLogistik,

    // Komoditas
    jenisPengirimanPesanan: localStorage.komoditasJenisPengirimanPesanan,
    penyediaJasaPengiriman: localStorage.komoditasPenyediaJasaPengiriman,
    kontakPenyediaJasaPengiriman: localStorage.komoditasKontakPenyediaJasaPengiriman,
    tanggalMulaiPenjemputan: localStorage.komoditasTanggalMulaiPenjemputan,
    waktuMulaiPenjemputan: localStorage.komoditasWaktuMulaiPenjemputan,
    kodePenjualanPenjemputan: localStorage.komoditasKodePenjualanPenjemputan,
    kodePenjualanPengiriman: localStorage.komoditasKodePenjualanPengiriman,
    faktur: localStorage.komoditasFaktur,
    jarakTempuh: localStorage.komoditasJarakTempuh,
    waktuTempuh: localStorage.komoditasWaktuTempuh,
    nilaiKomisi: localStorage.komoditasNilaiKomisi,
      
    // Pergerakan Barang
    statusPergerakanBarang: '',
    tipeStatusPergerakanBarang: [
        'Direncanakan',
        'Dilaksanakan',
    ], 
    kendaraanAngkut: '',
    tipeKendaraanAngkut: [
        'Truk',
        'Tronton',
        'Mobil Pick-up',
        'Kapal Laut',
        'Pesawat Terbang',
    ], 
    kodePesananPenjemputanLogistik: '',
    instruksiKhususPenjemputan: '',
    kodePesananPengirimanLogistik: '',
    instruksiKhususPengiriman: '',

  }),

  computed: {
    tipeDocs() {
      return [
        'Dokumen Usaha Dagang Perantara',
        this.kodePenjualan
      ]
    },

    // Form Check
    isComplete(){
        return (this.statusPergerakanBarang) && (this.kendaraanAngkut) && (this.kodePesananPenjemputanLogistik && this.kodePesananPenjemputanLogistik.length == 9) && (this.kodePesananPengirimanLogistik && this.kodePesananPengirimanLogistik.length == 9);
    },

    // Bagian Umum

    isStatusPergerakanBarang(){
        return (this.statusPergerakanBarang);
    },

    // Penjelasan Pergerakan Barang

    isKendaraanAngkut(){
        return (this.kendaraanAngkut);
    },

    // Penjemputan

    isKodePesananPenjemputanLogistik(){
        return (this.kodePesananPenjemputanLogistik && this.kodePesananPenjemputanLogistik.length == 9);
    },

    isIntruksiKhususPenjemputan(){
        return (this.instruksiKhususPenjemputan);
    },

    // Pengiriman

    isKodePesananPengirimanLogistik(){
        return (this.kodePesananPengirimanLogistik && this.kodePesananPengirimanLogistik.length == 9);
    },

    isIntruksiKhususPengiriman(){
        return (this.instruksiKhususPengiriman);
    },
  },

  methods: {

    closeDialog () {
      this.$parent.isActive = false;
    },

    back(){
      window.getApp.$emit('APP_KOMODITAS_LOGISTIK');
      // return '/pemerintah';
    },

    saveTemplate(){
        // Pergerakan Barang
        localStorage.pergerakanBarangStatus = this.statusPergerakanBarang,
        localStorage.pergerakanBarangKendaraanAngkut = this.kendaraanAngkut,
        localStorage.pergerakanBarangKodePesananPenjemputanLogistik = this.kodePesananPenjemputanLogistik,
        localStorage.pergerakanBarangInstruksiKhususPenjemputan = this.instruksiKhususPenjemputan,
        localStorage.pergerakanBarangKodePesananPengirimanLogistik = this.kodePesananPengirimanLogistik,
        localStorage.pergerakanBarangInstruksiKhususPengiriman = this.instruksiKhususPengiriman,

        window.getApp.$emit('APP_SIMPAN_TEMPLATE');
    },

    getPesananPengiriman (){
        // Pergerakan Barang
        localStorage.pergerakanBarangStatus = this.statusPergerakanBarang,
        localStorage.pergerakanBarangKendaraanAngkut = this.kendaraanAngkut,
        localStorage.pergerakanBarangKodePesananPenjemputanLogistik = this.kodePesananPenjemputanLogistik,
        localStorage.pergerakanBarangInstruksiKhususPenjemputan = this.instruksiKhususPenjemputan,
        localStorage.pergerakanBarangKodePesananPengirimanLogistik = this.kodePesananPengirimanLogistik,
        localStorage.pergerakanBarangInstruksiKhususPengiriman = this.instruksiKhususPengiriman,

        // Sistem
        localStorage.pergerakanBarangID = 'PERID-19040'
        localStorage.komoditasPergerakanBarangAktif = moment().format('DD-MM-YYYY');
        localStorage.komoditasPesananLogistik = 'true'

        window.getApp.$emit('APP_ULAS_PESANAN_PENGIRIMAN_LOGISTIK');

    }
  }
};
</script>

<style lang="stylus" scoped>
  .quill
    height : 360px
</style>
